import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=1ffa076c&scoped=true&"
import script from "./TopMenu.vue?vue&type=script&lang=ts&"
export * from "./TopMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TopMenu.vue?vue&type=style&index=0&id=1ffa076c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa076c",
  null
  
)

export default component.exports